<template>
  <div v-if="init" class="amap-traffic-layer-tool">
    <Teleport to="#amap-control">
      <div :class="{ 'traffic-control': true, 'traffic-active': !!trafficLayer }">
        <el-tooltip content="交通图层" effect="dark" placement="left">
          <img src="@p-v/packages/Map/AMapChart/assets/traffic.png" alt="交通图层" class="traffic-icon" @click="toggleTraffic" />
        </el-tooltip>
      </div>
    </Teleport>
  </div>
</template>

<script lang="ts" setup>
import { ref, inject, watch, onMounted } from "vue"
import { ElTooltip } from "element-plus"

defineOptions({
  name: "AMapTrafficLayer",
})

const props = defineProps({
  // 是否初始化完成
  show: {
    type: Boolean,
    default: false,
  },
})
const init = ref<boolean>(false)

const emit = defineEmits(["traffic-toggle"])

// 从父组件注入地图实例
const amap = inject<any>("amap")

const trafficLayer = ref<any | null>(null)

// 监听地图实例变化
watch(
  () => amap.value,
  map => {
    if (map) {
      // 初始化交通图层工具
      console.log("初始化交通图层工具", map)
      init.value = true
    }
  },
  { immediate: true },
)

const showTraffic = () => {
  if (!amap.value) return

  // 添加交通图层
  addTrafficLayer()

  // 发送状态变更事件
  emit("traffic-toggle", !!trafficLayer.value)
}

// 切换交通图层显示/隐藏
const toggleTraffic = () => {
  if (!amap.value) return

  if (trafficLayer.value) {
    // 移除交通图层
    removeTrafficLayer()
  } else {
    // 添加交通图层
    addTrafficLayer()
  }

  // 发送状态变更事件
  emit("traffic-toggle", !!trafficLayer.value)
}

// 添加交通图层
const addTrafficLayer = () => {
  if (!amap.value) return

  if (!trafficLayer.value) {
    // 创建交通图层
    trafficLayer.value = new window.AMap.TileLayer.Traffic({
      zIndex: 10,
    })
    // 添加到地图
    amap.value.add(trafficLayer.value)
  }
}

// 移除交通图层
const removeTrafficLayer = () => {
  if (!amap.value || !trafficLayer.value) return

  // 从地图移除图层
  amap.value.remove(trafficLayer.value)
  trafficLayer.value = null
}

onMounted(() => {
  // 如果初始状态为显示，则自动显示交通图层
  if (props.show) {
    addTrafficLayer()
  }
})

// 暴露方法
defineExpose({
  toggleTraffic,

  showTraffic,
})
</script>

<style scoped>
.amap-traffic-layer-tool {
  /* 不需要定位，因为使用了 Teleport */
}

.traffic-control {
  background-color: white;
  padding: 5px;
  filter: grayscale(1);
  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.traffic-active {
  filter: none;
}
</style>
